import AppLayout from '@layouts/AppLayout';
import type { FC } from 'react';

import ScheduledEmailsContainer from '@components/containers/reportSchedule/ScheduledEmailsContainer';

const ScheduledEmails: FC = () => {
    return (
        <AppLayout>
            <ScheduledEmailsContainer />
        </AppLayout>
    );
};

export default ScheduledEmails;
